<template>
  <el-dialog
    title="任务详情"
    :visible.sync="dialogVisible"
    width="480px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <div class="item-box item-box1">
        <div class="item">{{ info.taskTitle }}</div>
        <div class="cs" v-if="info.hasHour < 0">超期</div>
        <div class="cs"   style="color: #FF8B46;" v-else>剩余{{ info.hasHour }}小时</div>
        <img
          v-if="info.taskLevel == '应急'"
          style="height:24px;"
          src="@/assets/image/yj.png"
          alt=""
        />
      </div>
      <div class="item-box item-box2">
        <img class="icon" src="@/assets/image/wz.png" alt="" />
        <div class="label">点位</div>
        <div class="value">{{ info.pointName }}</div>
      </div>
      <div class="item-box item-box2">
        <img class="icon" src="@/assets/image/jq.png" alt="" />
        <div class="label">网格</div>
        <div class="value">{{ info.communityName }} | {{ info.blockName }}</div>
      </div>
      <div class="item-box item-box2">
        <img class="icon" src="@/assets/image/sj.png" alt="" />
        <div class="label">创建时间</div>
        <div class="value">{{ info.createTime }}</div>
      </div>
      <!-- <div class="item-box item-box3">
        <img
          style="height:40px;margin-right:8px;"
          src="@/assets/image/zxr.png"
          alt=""
        />
        <div class="item1">张女士</div>
        <div class="item2">创建时间</div>
        <div class="item3">{{info.createTime}}</div>
      </div> -->
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { detailTask } from "@/api/task.js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    curId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      info: {}
    };
  },
  mounted() {
    this.detailTaskFun();
  },
  methods: {
    async detailTaskFun() {
      const res = await detailTask({ id: this.curId });
      this.info = res.data.data;
    },
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none !important;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
}

/deep/.el-input {
  width: auto !important;
}
.container-dialog {
  padding: 25px 36px;
  .item-box {
    display: flex;
    align-items: center;
  }
  .item-box1 {
    .item {
      margin-right: 8px;
      font-family: MiSans, MiSans;
      font-weight: 700;
      font-size: 24px;
      color: #494c4f;
    }
    .cs {
      margin-right: 8px;
      background: rgba(235, 53, 56, 0.1);
      border-radius: 4px;
      padding: 2px 8px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #eb3538;
    }
  }
  .item-box2 {
    margin-top: 12px;
    .icon {
      // width: 22px;
      height: 18px;
      margin-right: 10px;
    }
    .label {
      padding: 0;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #92979c;
      margin-right: 12px;
    }
    .value {
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #494c4f;
    }
  }
  .item-box3 {
    margin-top: 12px;
    .item1 {
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #494c4f;
      margin-right: 21px;
    }
    .item2 {
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #92979c;
      margin-right: 8px;
    }
    .item3 {
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #494c4f;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/task/taskList/components/addDialog.vue